import { fetcher } from '@commenda/utils';
import { templateVersionsUrl } from './helpers';

export const updateDocumentAssemblerTemplateVersionGuidance = async (
  templateId: string,
  versionId: string,
  authorGuidance: string
): Promise<Response> => {
  const res = await fetcher(`${templateVersionsUrl(templateId)}/${versionId}`, {
    method: 'POST',
    body: { authorGuidance },
  });
  return res;
};
